import TabHeader from "../../../../common/DroppedFileList/components/TabHeader";
import XMLViewer from "../../../../common/XmlViewer/XmlViewer";

const AdditionalDetailsContent = ({ activeMenu, additionalDetails }) => {
  const isDisabled = additionalDetails || additionalDetails[activeMenu.id].length === 0;

  //   const downloadHandler = () => {
  //     const blob = new Blob([additionalDetails[activeMenu.id].join("\n")], {
  //       type: "plain/text",
  //     });
  //     const url = URL.createObjectURL(blob);

  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `CFSBOX_IOC_${activeMenu.header}_${generalInfo?.sha1}.txt`;
  //     document.body.appendChild(a);
  //     a.click();

  //     URL.revokeObjectURL(url);
  //     document.body.removeChild(a);
  //   };

  return (
    <div className="iocs__content">
      <div className="iocs__content__header">
        <h3>{activeMenu.header}</h3>
        {/* <button className="iocs__content__download" disabled={isDisabled} onClick={downloadHandler}>
          Download
        </button> */}
      </div>

      {/* <div className="iocs__content__mid">
        <p>{activeMenu.description}</p>
      </div> */}

      <div className="iocs__content__table">
        <TabHeader active={true} setActive={() => {}} />
        <div className="iocs__content__list">
          {Object.keys(additionalDetails).length > 0 ? (
            Array.isArray(additionalDetails[activeMenu.id]) &&
            additionalDetails[activeMenu.id].length > 0 ? (
              additionalDetails[activeMenu.id]?.map((additionalDetail, i) => (
                <p className="iocs__content__row" key={i}>
                  {additionalDetail}
                </p>
              ))
            ) : typeof additionalDetails[activeMenu.id] === "string" &&
              activeMenu.id === "manifest_xml" ? (
              <XMLViewer xmlString={additionalDetails[activeMenu.id]} />
            ) : (
              <p className="iocs__content__no-data">No data</p>
            )
          ) : (
            <p className="iocs__content__no-data">No data</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdditionalDetailsContent;
